import { ProductCardSkeleton } from "src/molecules/ProductCardSkeleton";

function GridSkeleton({
  numberOfItems = 72,
}: {
  numberOfItems?: number;
}): JSX.Element {
  return (
    <>
      {[...new Array<undefined>(numberOfItems)].map((_, index) => (
        <ProductCardSkeleton key={`product-skeleton-${index}`} />
      ))}
    </>
  );
}

export { GridSkeleton };
